import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Col, Row } from 'rsuite';
import { HOA_OPTIONS } from 'src/components/payment/constants';
import { PersonInfo, ROLES } from 'src/components/confirmation/PersonInfo';
import { selectConfigExpressRegistrationHoa } from 'src/store/slices/config/configSelectors';
import { ApplicationData } from 'src/types/flow';
import { Person } from 'src/types/person';

interface PeopleProps {
  permitVerbiage: string;
  localContactVerbiage: string;
  data: ApplicationData;
}

export const People = ({
  permitVerbiage,
  localContactVerbiage,
  data,
}: PeopleProps) => {
  const hoaConfiguration = useSelector(selectConfigExpressRegistrationHoa);

  const showHoa = useMemo(
    () =>
      (hoaConfiguration?.enable ?? false) &&
      data.contacts?.hoaAnswer === HOA_OPTIONS.YES,
    [hoaConfiguration, data.contacts?.hoaAnswer]
  );

  return (
    <Row>
      <Col
        xs={24}
        lg={12}
      >
        <h2 className="mt-8">{permitVerbiage} Holder</h2>
        <PersonInfo
          data={data}
          role={ROLES.PERMIT_HOLDER}
        />
        <h2 className="mt-8">
          Owner
          {(data?.registrant?.owner as Person[])?.length > 0 && 's'}
        </h2>
        <PersonInfo
          data={data}
          role={ROLES.OWNER}
        />
      </Col>
      <Col
        xs={24}
        lg={12}
      >
        <h2 className="mt-8">Property Manager</h2>
        <PersonInfo
          data={data}
          role={ROLES.PROPERTY_MANAGER}
        />

        <h2 className="mt-8">{localContactVerbiage}</h2>
        <PersonInfo
          data={data}
          role={ROLES.OWNER_REPRESENTATIVE}
        />

        {showHoa && (
          <>
            <h2 className="mt-8">Home Owner’s Association (HOA)</h2>
            <PersonInfo
              data={data}
              role={ROLES.HOA}
            />
          </>
        )}
      </Col>
    </Row>
  );
};
